import { render, staticRenderFns } from "./CompanyUserForm.vue?vue&type=template&id=32338b26&scoped=true"
import script from "./CompanyUserForm.vue?vue&type=script&lang=ts"
export * from "./CompanyUserForm.vue?vue&type=script&lang=ts"
import style0 from "./CompanyUserForm.vue?vue&type=style&index=0&id=32338b26&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32338b26",
  null
  
)

export default component.exports